var $ = window.jQuery = require('jquery');
import {
  bus
} from '@/main';
import appFooter from '@/components/footer/index';
import Slick from 'vue-slick';
import axios from 'axios';
import root from '@/_helpers/roots';

// Multi Color Bg Img Of Section
import variation_random_img1 from '@/assets/images/random_img/oddnary-variation-5.jpg';
import variation_random_img2 from '@/assets/images/random_img/oddnary-variation-7.jpg';
import variation_random_img3 from '@/assets/images/random_img/oddnary-variation-1.jpg';
import variation_random_img4 from '@/assets/images/random_img/oddnary-variation-4.jpg';
import variation_random_img5 from '@/assets/images/random_img/oddnary-variation-2.jpg';
import variation_random_img6 from '@/assets/images/random_img/oddnary-variation-6.jpg';

export default {
  name: 'media-details',
  components: {
    'app-footer': appFooter,
    Slick
  },
  props: [],
  data() {
    return {
      preloader: true,
      slickOptions: {
        slidesToShow: 4,
        slidesToScroll: 1,
        initialSlide: 1,
        vertical: true,
        infinite: true,
        adaptiveHeight: true
      },
      mediaDetails: {},
      imageIndex:''
    }
  },
  computed: {

  },
  mounted() {
    bus.$emit('showHomeMenuBtn', true);
    bus.$emit('showQuizMenubtn', true);
    let mediaId = this.$route.params.mediaId
    this.getMediaDetails(this.$route.params.mediaId);
    if (process.env.NODE_ENV == 'production') {
      this.$scriptLoader.load("https://www.googletagmanager.com/gtag/js?id=UA-152519411-1")
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'UA-152519411-1');
    }
    this.randomImgLoaded()
  },
  methods: {
    randomImgLoaded() {
      $('.app-loader').show()
      // Multi Color Bg Img Of Section
      var images = ["random_img1", "random_img2", "random_img3", "random_img4", "random_img5", "random_img6"]
      var variation_images = [variation_random_img1, variation_random_img2, variation_random_img3, variation_random_img4, variation_random_img5, variation_random_img6]
      var size = images.length;
      var x = Math.floor(size * Math.random());
      this.imageIndex = x
      var element = document.getElementsByClassName('media_details_main');
      if (x < images.length) {
        $('.navbar_list_wrp').addClass('act_contest_clr_of_holders' + x);
        $('.media_details_main').addClass('act_contest_clr_of_holders' + x);
        element[0].style["background-image"] = "url(" + variation_images[x] + ")"
        setTimeout(() => {
          $('.app-loader').hide()
        }, 1000);
      }
    },
    checkEmptyObject(obj) {
      return Object.keys(obj).length > 0 ? false : true;
    },
    getMediaDetails: function(mediaId) {
      $('.routeloader').css({
        'display': 'flex'
      });
      let mediaListUrlLink = root.mediaListLink.link + mediaId + '/';
      axios.get(mediaListUrlLink).then(response => {
        if (response.status === 200) {
          this.mediaDetails = response.data.data;
          $('.routeloader').hide();
        }
      }).catch(err => {
        console.error(err);
        $('.routeloader').hide();
      })
    },
    calcDateDifference(startingDate, endingDate) {
      var startDate = new Date(new Date(startingDate).toISOString().substr(0, 10));
      if (!endingDate) {
        endingDate = new Date().toISOString().substr(0, 10); // need date in YYYY-MM-DD format
      }
      var endDate = new Date(endingDate);
      if (startDate > endDate) {
        var swap = startDate;
        startDate = endDate;
        endDate = swap;
      }
      var startYear = startDate.getFullYear();
      var february = (startYear % 4 === 0 && startYear % 100 !== 0) || startYear % 400 === 0 ? 29 : 28;
      var daysInMonth = [31, february, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

      var yearDiff = endDate.getFullYear() - startYear;
      var monthDiff = endDate.getMonth() - startDate.getMonth();
      if (monthDiff < 0) {
        yearDiff--;
        monthDiff += 12;
      }
      var dayDiff = endDate.getDate() - startDate.getDate();
      if (dayDiff < 0) {
        if (monthDiff > 0) {
          monthDiff--;
        } else {
          yearDiff--;
          monthDiff = 11;
        }
        dayDiff += daysInMonth[startDate.getMonth()];
      }
      let year = yearDiff > 0 ? yearDiff + (yearDiff > 1 ? ' years ' : ' year ') : '';
      let month = monthDiff > 0 ? monthDiff + (monthDiff > 1 ? ' months ' : ' month ') : '';
      let day = dayDiff > 0 ? dayDiff + (dayDiff > 1 ? ' days ' : ' day ') : '';
      return year + month + day + 'ago';
    }
  },
  watch: {
    '$route.params.mediaId'(newId, oldId) {
      this.getMediaDetails(newId)
    }
  },
  beforeRouteLeave: function(to, from, next) {
    $('.navbar_list_wrp').removeClass('act_contest_clr_of_holders' + this.imageIndex);
    $('.media_details_main').removeClass('act_contest_clr_of_holders' + this.imageIndex);
    next();
  }
}